import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { client } from 'global/Models/clientModel';

type initialStateType = {
  clientList: client[] | undefined;
};

const initialState: initialStateType = {
  clientList: undefined,
};

export const clientSlice = createSlice({
  name: 'client',
  initialState,
  reducers: {
    setAllClient: (state, action: PayloadAction<client[]>) => {
      state.clientList = action.payload;
    },
  },
});

export const { setAllClient } = clientSlice.actions;

export default clientSlice.reducer;
